export default __webpack_public_path__ + "static/media/createPolicy-icon.c9921092.svg";